import axios from 'axios'

export default {
  getConversations () {
    return axios.get('/conversations')
  },
  getConversationMessages (conversationId: string) {
    return axios.get(`/conversations/${conversationId}/messages`)
  },
  postPrompt (mnemo: string, prompt: string, conversationId: string | null) {
    return axios.post(`/room/${mnemo}/ai-ask`, { prompt, conversationId })
  },
  async postStreamedPrompt (mnemo: string, prompt: string, conversationId: string | null, messageId: string | null = null, retry: boolean = false) {
    // axios doesn't support streaming responses natively, so we'll have to resort to using fetch instead
    const baseURL = axios.defaults.baseURL || ''
    const url = `${baseURL}/room/${mnemo}/ai-ask-stream`
    const urlRetry = `${baseURL}/room/${mnemo}/ai-ask-retry/${messageId}`

    // fetching headers
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    }

    // now we're reusing said headers to include auth tokens, etc.
    if (axios.defaults.headers.common) {
      for (const [key, value] of Object.entries(axios.defaults.headers.common)) {
        if (typeof value === 'string') {
          headers[key] = value
        }
      }
    }

    return fetch(retry ? urlRetry : url, {
      method: 'POST',
      headers,
      body: JSON.stringify({ prompt, conversationId }),
      credentials: 'include', // to include cookies if any
    })
  },
}
